import { useEffect } from 'react';
import { trackEvent } from '../lib/appInsights';
import { routeUrls } from '../routes';

export const NotFoundPage = () => {
    useEffect(() => {
        trackEvent('NotFoundPage', { url: window.location.href });
    }, []);

    return (
        <div className="container mx-auto h-full">
            <div className="flex flex-col items-center justify-center h-full">
                <h1 className="text-3xl font-bold">Pagina niet gevonden</h1>
                <a className="rounded bg-primary text-white px-5 py-2 mt-10" href={routeUrls.DASHBOARD}>
                    Ga naar mijn dashboard
                </a>
            </div>
        </div>
    );
};
